import React, { useEffect, useState } from 'react';
import Service from '../Dashboard/services/Service';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './Medication.scss';

const MedicationPage = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    handleGetSupplement();
  }, []);

  const handleGetSupplement = async () => {
    setLoading(true);
    try {
      const statusResponse = await Service.checkMedicationFormStatus();

      if (statusResponse.data && statusResponse.data.payment_status) {
        setLoading(false);
        Swal.fire({
          title: 'All Done!',
          text: 'You have completed the form and payment. Go to dashboard.',
          icon: 'success',
          confirmButtonText: 'Go to Dashboard',
        }).then(() => {
          window.location.href = '/dashboard';
        });
        return;
      }

      if (statusResponse.data && statusResponse.data.case_id_exists) {
        setLoading(false);
        Swal.fire({
          title: 'Form Completed',
          text: 'Your intake form is already completed. Proceed to payment.',
          icon: 'success',
          confirmButtonText: 'Proceed to Payment',
          showCloseButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/payment';
          } else if (result.isDismissed) {
            window.location.href = '/dashboard';
          }
        });
        return;
      }

      let response;
      if (statusResponse.data && statusResponse.data.is_voucher_used === false && statusResponse.data.voucher_link) {
        response = { data: { voucher_link: statusResponse.data.voucher_link, voucher_id: statusResponse.data.voucher_id } };
      } else {
        response = await Service.startMedicationWithVoucher();
      }

      if (response.data && response.data.voucher_link && response.data.voucher_id) {
        const voucherId = response.data.voucher_id;
        sessionStorage.setItem('medicationRequestId', voucherId);

        setLoading(false);

        Swal.fire({
          title: 'Complete Your Intake Form',
          text: 'Before proceeding, please complete your intake form.',
          icon: 'info',
          confirmButtonText: 'Fill Intake Form',
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isDismissed) {
            window.location.href = '/dashboard';
            return;
          }

          window.open(response.data.voucher_link, '_blank');

          const showPaymentPrompt = async () => {
            Swal.fire({
              title: 'Form Opened',
              text: 'After completing the form, click below to proceed to payment.',
              icon: 'success',
              confirmButtonText: 'Proceed to Payment',
              showCloseButton: true,
              showLoaderOnConfirm: true,
              preConfirm: async () => {
                try {
                  const statusResponse = await Service.checkMedicationFormStatus();

                  if (statusResponse.data && statusResponse.data.case_id_exists) {
                    return true;
                  } else {
                    Swal.showValidationMessage(
                      'Please fill the intake form first before proceeding to payment OR if you are not medically qualified, you can close the tab.'
                    );
                    return false;
                  }
                } catch (error) {
                  Swal.showValidationMessage('Failed to verify form status.');
                  return false;
                }
              },
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isDismissed) {
                window.location.href = '/dashboard';
              } else if (result.isConfirmed && result.value) {
                window.location.href = '/payment';
              }
            });
          };

          showPaymentPrompt();
        });
      } else {
        toast.error('Failed to get intake form link.');
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Failed to start supplement request.');
      setLoading(false);
    }
  };

  return <div className="medication-page">{loading && <div className="loading-spinner">Loading...</div>}</div>;
};

export default MedicationPage;
